import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'it', label: 'Italiano', flag: '🇮🇹' },
];

const LanguageSwitcher: React.FC = () => {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const current = LANGUAGES.find((l) => l.code === i18n.language) ?? LANGUAGES[0];

    const change = (code: string) => {
        i18n.changeLanguage(code);
        localStorage.setItem('et_language', code);
        setOpen(false);
    };

    // Close on outside click
    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    return (
        <div ref={ref} className="relative flex items-center justify-center px-4 py-2">
            <button
                onClick={() => setOpen((v) => !v)}
                className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-slate-700 transition-all text-sm"
            >
                <span className="text-base">{current.flag}</span>
                <span className="text-xs font-bold uppercase">{current.code}</span>
                <i className={`fa-solid fa-chevron-${open ? 'up' : 'down'} text-[10px]`}></i>
            </button>

            {open && (
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-36 bg-slate-800 border border-slate-700 rounded-xl shadow-xl overflow-hidden z-50">
                    {LANGUAGES.map((lang) => (
                        <button
                            key={lang.code}
                            onClick={() => change(lang.code)}
                            className={`w-full flex items-center gap-2.5 px-3 py-2 text-sm transition-colors ${
                                i18n.language === lang.code
                                    ? 'bg-slate-700 text-white font-semibold'
                                    : 'text-slate-400 hover:bg-slate-700 hover:text-white'
                            }`}
                        >
                            <span className="text-base">{lang.flag}</span>
                            <span>{lang.label}</span>
                            {i18n.language === lang.code && (
                                <i className="fa-solid fa-check text-cyan-400 text-xs ml-auto"></i>
                            )}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSwitcher;
